import { deriveTaxonomyLevelsFromFacets } from 'src/adapters/storeToPageURL/deriveTaxonomyLevelsFromFacets';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectPathname } from 'src/redux/navigation/selectors';
import type { Facet } from 'src/redux/productsQuery/types/Facet';

export type ListingsBasePathParts = {
  levels: string[];
  pathname: string;
  routeLiteral: string;
};

export const selectListingsBasePathParts = (
  state: ReduxApplicationState,
  facets: Facet[] = state.productsQuery.facets,
): ListingsBasePathParts => {
  const pathname = selectPathname(state) ?? '/';
  const routeLiteral = pathname.split('/').filter((segment) => segment.length > 0)[0] ?? '';
  const { taxonomyAttributeAliases = [] } = state.productsQuery;

  if (taxonomyAttributeAliases.length === 0) {
    return { pathname, routeLiteral, levels: [] };
  }

  return {
    pathname,
    routeLiteral,
    levels: deriveTaxonomyLevelsFromFacets(facets, taxonomyAttributeAliases),
  };
};

export const selectFacetByKey = (state: ReduxApplicationState, uid: string): Facet | null => {
  return state.productsQuery.facets.find((facet) => facet.key === uid) || null;
};

export const selectTotalActiveOptions = (state: ReduxApplicationState) => {
  return state.productsQuery.facets.reduce((total, facet) => {
    const activeOptionsCount = facet.options.filter((option) => option.active).length;

    total = total + activeOptionsCount;

    return total;
  }, 0);
};

export const selectActiveFacets = (state: ReduxApplicationState) => {
  return state.productsQuery.facets.filter((facet) =>
    facet.options.some((option) => option.active),
  );
};

export const selectActiveSortOption = (state: ReduxApplicationState) => {
  return state.productsQuery.sortOptions.find((option) => option.active) || null;
};
